import EditCustomerModule from "modules/Admin/customers/EditCustomer"

function EditCustomerPage() {
  return (
    <div data-testid="adminEditCustomerPage">
      <EditCustomerModule />
    </div>
  )
}

export default EditCustomerPage